import API from "../../../api.js";
import {
  LAB_LIST_REQUEST,
  LAB_LIST_SUCCESS,
  LAB_LIST_FAIL,
} from "../../constants/patientConstants/labConstants.js";

export const listLabs = () => async (dispatch) => {
  try {
    dispatch({ type: LAB_LIST_REQUEST });
    const { data } = await API.get("/labreports");
    dispatch({ type: LAB_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: LAB_LIST_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};
